/* SEYUN · moteur d'offres unique (29/10). Remplace Moon Bundles (bundles savon, cadeaux, tiroir) et seyun-cart-integrity.js.
   Source unique : offers.json -> snippets/seyun-offers-config.liquid (JSON généré par bench/gen_offers.py, ne pas éditer à la main).
   Règles (Cédric 29/10) : 5 marchés (USD, AUD, CAD, NZD, GBP) au prix exact de Moon ; prix = combinaison de packs la moins chère
   pour la quantité totale du produit ; 1 code pourcentage par offre, réservé au marché de la devise du panier ; hors de ces devises,
   aucun code ni cadeau ; Complete Routine = propriété de ligne _seyun_offer=routine, 2 barres minimum, cadeaux retirés si elle part ;
   codes saisis par le client jamais retirés ; 5 codes max par panier. */
(function (root) {
  'use strict';

  /* ---------- coeur pur (testé en Node par bench/run_bench.py) ---------- */
  var MAX_CODES = 5;
  function upper(c) { return String(c || '').trim().toUpperCase(); }
  function codeFor(plan, q) {
    if (!plan || !q) return '';
    return q < plan.length ? plan[q] : plan[plan.length - 1]; /* au-delà du plafond : le code du plafond */
  }
  function isRoutine(l) { return (l.properties || {})._seyun_offer === 'routine'; }
  function plan(cart, cfg) {
    var cur = upper(cart.currency), plans = (cfg.plans || {})[cur] || null;
    var managed = {}; (cfg.managed || []).forEach(function (c) { managed[upper(c)] = 1; });
    var lines = cart.items || [], updates = {}, adds = [], wanted = [], qty = {}, need = {};
    var giftIds = {}; (cfg.gift_variants || []).forEach(function (v) { giftIds[v] = 1; need[v] = 0; });
    var groups = {};
    (cfg.offers || []).forEach(function (o) { (groups[o.variant] = groups[o.variant] || []).push(o); });
    Object.keys(groups).forEach(function (vid) {
      var mine = lines.filter(function (l) { return String(l.variant_id) === vid && !l.selling_plan_allocation; });
      var q = mine.reduce(function (s, l) { return s + l.quantity; }, 0);
      if (!q) return;
      var routine = mine.some(isRoutine), o = groups[vid].filter(function (x) { return routine ? x.mode === 'routine' : !x.mode; })[0];
      if (!o) return;
      if (o.min_qty && q < o.min_qty) { /* un clic sur « - » ne transforme jamais la Routine en barre plein tarif */
        var l0 = mine.filter(isRoutine)[0]; updates[l0.key] = l0.quantity + (o.min_qty - q); q = o.min_qty;
      }
      qty[o.id] = q;
      if (!plans) return;
      var c = codeFor(plans[o.id], q); if (c) wanted.push(upper(c));
      (o.gifts || []).forEach(function (g) { if (q >= g.min) need[g.variant] = (need[g.variant] || 0) + 1; });
    });
    /* cadeaux : vraies lignes des produits cadeaux dédiés (remise auto 100 %), gérées uniquement par le moteur */
    Object.keys(need).forEach(function (vid) {
      var have = lines.filter(function (l) { return String(l.variant_id) === vid; }), n = need[vid];
      if (have.length) have.forEach(function (l, i) { var w = i === 0 ? n : 0; if (l.quantity !== w) updates[l.key] = w; });
      else if (n) adds.push({ id: Number(vid), quantity: n });
    });
    var current = (cart.discount_codes || []).filter(function (d) { return d.applicable !== false || managed[upper(d.code || d)]; })
      .map(function (d) { return upper(d.code || d); }).filter(Boolean);
    var all = (cart.discount_codes || []).map(function (d) { return upper(d.code || d); }).filter(Boolean);
    var customer = all.filter(function (c) { return !managed[c]; });
    var finalCodes = customer.slice(), dropped = [];
    wanted.forEach(function (c) { if (finalCodes.indexOf(c) !== -1) return; if (finalCodes.length < MAX_CODES) finalCodes.push(c); else dropped.push(c); });
    var sameCodes = finalCodes.length === all.length && finalCodes.every(function (c) { return all.indexOf(c) !== -1; });
    Object.keys(updates).forEach(function (k) { var l = lines.filter(function (x) { return x.key === k; })[0]; if (l && l.quantity === updates[k]) delete updates[k]; });
    return { updates: updates, adds: adds, codes: finalCodes, discount: sameCodes ? null : finalCodes.join(','), qty: qty, dropped: dropped, current: current,
             changed: !sameCodes || Object.keys(updates).length > 0 || adds.length > 0 };
  }
  var core = { plan: plan, codeFor: codeFor };
  if (typeof module !== 'undefined' && module.exports) module.exports = core;
  if (!root || !root.document || root.SeyunOffers) return;

  /* ---------- navigateur ---------- */
  var w = root, doc = w.document, cfg;
  try { cfg = JSON.parse(doc.getElementById('seyun-offers-config').textContent); } catch (e) { cfg = null; }
  if (!cfg || !cfg.offers) { console.warn('[seyun-offers] config absente'); return; }
  var nativeFetch = w.fetch.bind(w), SECTIONS = 'cart-drawer,cart-icon-bubble';
  function base() { return (w.Shopify && w.Shopify.routes && w.Shopify.routes.root) || '/'; }
  function call(path, body) {
    return nativeFetch(base() + path, body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) { var e = new Error(j.description || j.message || 'Error'); e.data = j; throw e; } return j; }); });
  }
  function checkout(off) {
    doc.querySelectorAll('#CartDrawer-Checkout, #checkout, [name="checkout"]').forEach(function (b) { if (off) b.setAttribute('disabled', ''); else b.removeAttribute('disabled'); });
  }
  function render(state) {
    if (location.pathname.replace(/\/$/, '').slice(-5) === '/cart') { location.reload(); return; }
    var d = doc.querySelector('cart-drawer');
    if (d && d.renderContents && state && state.sections) {
      var wasOpen = d.classList.contains('active');
      if (state.item_count) d.classList.remove('is-empty'); else d.classList.add('is-empty');
      d.renderContents(state);
      if (!wasOpen) setTimeout(function () { d.close && d.close(); }, 0);
    }
    if (typeof w.publish === 'function' && w.PUB_SUB_EVENTS) w.publish(w.PUB_SUB_EVENTS.cartUpdate, { source: 'seyun-offers', cartData: state });
    doc.dispatchEvent(new CustomEvent('seyun-offers:cart', { detail: state }));
  }
  var running = null, queued = false;
  function reconcile(redraw) {
    if (running) { queued = true; return running; }
    checkout(true);
    var pass = 0, wrote = false;
    function once(cart) {
      var p = plan(cart, cfg);
      if (p.dropped.length) console.warn('[seyun-offers] limite de 5 codes : non posés', p.dropped);
      if (!p.changed || pass++ > 2) {
        if (redraw && !wrote) return call('cart/update.js', { updates: {}, sections: SECTIONS, sections_url: location.pathname }).then(function (s) { render(s); return s; });
        return cart;
      }
      var step = p.adds.length ? call('cart/add.js', { items: p.adds }) : Promise.resolve();
      return step.then(function () {
        var body = { updates: p.updates, sections: SECTIONS, sections_url: location.pathname };
        if (p.discount !== null) body.discount = p.discount;
        return call('cart/update.js', body);
      }).then(function (state) { wrote = true; render(state); return once(state); });
    }
    running = call('cart.js').then(once)
      .catch(function (e) { console.warn('[seyun-offers]', e); })
      .then(function (state) { running = null; checkout(false); if (queued) { queued = false; return reconcile(true); } return state; });
    return running;
  }
  /* un seul hook fetch : toute écriture panier du thème ou d'un autre script -> une réconciliation (anti-rebond 150 ms) */
  var timer;
  w.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      checkout(true);
      p.then(function () { clearTimeout(timer); timer = setTimeout(function () { reconcile(true); }, 150); }, function () { checkout(false); });
    }
    return p;
  };
  /* les scripts d'offres existants (fd/vl/sm-sync) annoncent leurs changements avec cet événement */
  w.addEventListener('moonbundle-cart-updated', function () { clearTimeout(timer); timer = setTimeout(function () { reconcile(true); }, 150); });
  w.SeyunOffers = { config: cfg, plan: function (c) { return plan(c, cfg); }, reconcile: reconcile };

  /* ---------- bloc bundle PDP ---------- */
  function initBundle(box) {
    if (box.dataset.bound) return; box.dataset.bound = '1';
    var formId = box.dataset.form, form = formId && doc.getElementById(formId);
    if (!form) return;
    var prop = doc.createElement('input'); prop.type = 'hidden'; prop.name = 'properties[_seyun_offer]'; prop.value = 'routine'; prop.disabled = true;
    form.appendChild(prop);
    function qtyInputs() {
      var list = Array.prototype.slice.call(doc.querySelectorAll('input[name="quantity"][form="' + formId + '"]')).concat(Array.prototype.slice.call(form.querySelectorAll('input[name="quantity"]')));
      if (!list.length) { var h = doc.createElement('input'); h.type = 'hidden'; h.name = 'quantity'; form.appendChild(h); list = [h]; }
      return list;
    }
    function select(opt) {
      box.querySelectorAll('.sy-bundle__opt').forEach(function (o) { o.classList.toggle('is-selected', o === opt); var r = o.querySelector('input'); if (r) r.checked = o === opt; });
      var q = opt.dataset.qty, idx = Number(opt.dataset.idx);
      qtyInputs().forEach(function (i) { i.value = q; i.dispatchEvent(new Event('change', { bubbles: true })); });
      prop.disabled = opt.dataset.mode !== 'routine';
      box.querySelectorAll('.sy-bundle__gift').forEach(function (g) { g.classList.toggle('is-unlocked', idx >= Number(g.dataset.unlock)); });
    }
    function current() { return box.querySelector('.sy-bundle__opt.is-selected') || box.querySelector('.sy-bundle__opt'); }
    box.querySelectorAll('.sy-bundle__opt').forEach(function (o) { o.addEventListener('click', function () { select(o); }); });
    /* le thème remet la quantité à 1 au chargement : on la repose au chargement et juste avant l'envoi du formulaire */
    doc.addEventListener('submit', function (e) { if (e.target === form) select(current()); }, true);
    w.addEventListener('load', function () { select(current()); });
    select(current());
  }
  /* ---------- tiroir : upsell et barre de livraison gratuite ---------- */
  function initDrawer(scope) {
    (scope || doc).querySelectorAll('[data-sy-ship]').forEach(function (bar) {
      var rate = Number((w.Shopify && w.Shopify.currency && w.Shopify.currency.rate) || 1);
      var goal = Math.round(Number(bar.dataset.goal) * rate), total = Number(bar.dataset.total), left = Math.max(0, goal - total);
      var fmt = new Intl.NumberFormat('en', { style: 'currency', currency: bar.dataset.currency || 'USD', currencyDisplay: 'narrowSymbol' });
      /* n'écrire que ce qui change : l'observateur du tiroir se redéclencherait sinon à l'infini */
      if (bar.classList.contains('is-done') !== (left === 0)) bar.classList.toggle('is-done', left === 0);
      var amt = bar.querySelector('[data-left]'), txt = fmt.format(left / 100); if (amt && amt.textContent !== txt) amt.textContent = txt;
      var fill = bar.querySelector('.sy-ship__fill'), wd = Math.min(100, goal ? total / goal * 100 : 100).toFixed(2) + '%'; if (fill && fill.style.width !== wd) fill.style.width = wd;
    });
  }
  doc.addEventListener('click', function (e) {
    var add = e.target && e.target.closest && e.target.closest('[data-sy-upsell-add]');
    if (!add) return;
    e.preventDefault(); add.setAttribute('aria-busy', 'true'); add.disabled = true;
    w.fetch(base() + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(add.dataset.syUpsellAdd), quantity: 1 }] }) })
      .catch(function () { add.disabled = false; });
  });
  /* Filet de sécurité : jamais de checkout sans réconciliation. */
  var leaving = false;
  doc.addEventListener('click', function (e) {
    var b = e.target && e.target.closest && e.target.closest('#CartDrawer-Checkout, #checkout, [name="checkout"], a[href*="/checkout"]');
    if (!b || leaving) return;
    e.preventDefault(); e.stopImmediatePropagation();
    leaving = true;
    var go = function () { location.href = base() + 'checkout'; };
    Promise.resolve(running).then(function () { return reconcile(); }).then(go, go);
  }, true);
  function boot() { doc.querySelectorAll('[data-sy-bundle]').forEach(initBundle); initDrawer(); reconcile(); }
  doc.addEventListener('seyun-offers:cart', function () { initDrawer(); });
  function watchDrawer() { var d = doc.querySelector('cart-drawer'); if (d && w.MutationObserver) new MutationObserver(function () { initDrawer(d); }).observe(d, { childList: true, subtree: true }); }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', function () { watchDrawer(); boot(); }); else { watchDrawer(); boot(); }
  w.addEventListener('pageshow', function (e) { if (e.persisted) { leaving = false; reconcile(); } });
})(typeof window !== 'undefined' ? window : null);
